import Check from '@mui/icons-material/Check';
import ExpandMoreSharpIcon from '@mui/icons-material/ExpandMoreSharp';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';

type ValueSourceInfo = { label: string };

type AccessibilityMuiValueSourcesProps = {
  valueSources: [string, ValueSourceInfo][];
  valueSrc?: string;
  title: string;
  setValueSrc: (srcKey: string) => void;
  readonly?: boolean;
};

export default function AccessibilityMuiValueSources({
  valueSources,
  valueSrc,
  title,
  setValueSrc,
}: AccessibilityMuiValueSourcesProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleOpenClose = (event: React.MouseEvent<HTMLElement>) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    anchorEl ? handleClose() : handleOpen(event);
  };

  const handleChange = (_e: React.MouseEvent, srcKey: string) => {
    setValueSrc(srcKey);
    handleClose();
  };

  const renderOptions = () =>
    valueSources.map(([srcKey, info]) => {
      const isSelected = valueSrc === srcKey || (!valueSrc && srcKey === 'value');
      const onClick = (e: React.MouseEvent) => handleChange(e, srcKey);
      return (
        <MenuItem key={srcKey} value={srcKey} selected={isSelected} onClick={onClick}>
          {!isSelected && <ListItemText inset>{info.label}</ListItemText>}
          {isSelected && (
            <>
              <ListItemIcon>
                <Check />
              </ListItemIcon>
              {info.label}
            </>
          )}
        </MenuItem>
      );
    });

  const open = Boolean(anchorEl);

  return (
    <div>
      <IconButton size="small" onClick={toggleOpenClose} aria-label="Select value source">
        <ExpandMoreSharpIcon />
      </IconButton>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <FormControl component="fieldset" sx={{ p: 0 }}>
          <FormLabel component="legend" sx={{ p: 2, pt: 0, pb: 1 }}>
            {title}
          </FormLabel>
          {renderOptions()}
        </FormControl>
      </Menu>
    </div>
  );
}
